import React, { useEffect, useState, useRef } from 'react';
import { SideSheet, CheckoutTimeSlots } from '@desquared/wave-components-library';
import { TimesSlotsSideSheetStore } from '@/store/sideSheet';
import { useTranslations } from 'next-intl';

export default function TimeslotsAside({
  transformedTimeslots,
  genericIndexes,
  onChangeDayIndex,
  onChangeTimeslotIndex,
}) {
  const [sideSheet, setSideSheet] = useState(false);
  const refOne = useRef(null);
  const t = useTranslations('common.asides.prebook');

  const onClick = () => {
    setTimeout(() => {
      TimesSlotsSideSheetStore.close();
    }, '300');
  };
  useEffect(() => {
    const TimesSlotsSideSheetStore$ = TimesSlotsSideSheetStore.subscribe(setSideSheet);

    document.addEventListener('click', handleClickOutside, true);

    return () => {
      TimesSlotsSideSheetStore$.unsubscribe();

      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = e => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      TimesSlotsSideSheetStore.close();
    }
  };

  if (!sideSheet) return null;
  if (!transformedTimeslots) return null;
  return (
    <div ref={refOne}>
      <SideSheet
        header={t('header')}
        hasClose={true}
        onClose={onClick}
        buttonText={t('save_btn')}
        onSubmit={() => {
          onClick();
        }}
      >
        <CheckoutTimeSlots
          days={transformedTimeslots}
          selectedDayIndex={genericIndexes.selectedDayIndex}
          setSelectedDayIndex={onChangeDayIndex}
          selectedTimeslotIndex={genericIndexes.selectedIndex}
          setSelectedTimeslotIndex={onChangeTimeslotIndex}
        />
      </SideSheet>
    </div>
  );
}
